import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { getStepDetails, getSubTaskDetails } from 'visa-store';
import { environment } from 'environment-configurations';
import { DEPENDENT_VISAS } from 'app-models';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'reference-library';

class APIGenerateForms {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    postFormType(visatype, caseType, caseId, superTaskId, taskId, formType, payload) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/form/${formType}/generate?superTaskId=${superTaskId}&taskId=${taskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    // UPLOAD Start
    uploadDocument(visatype, caseType, caseId, superTaskId, taskId, formType, familyId, formData) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/form/${formType}/upload?superTaskId=${superTaskId}&taskId=${taskId}&familyId=${familyId}`, formData).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    // UPLOAD END
    deleteGreenCardUploadDocument(documentId) {
        return this.httpClient.delete(`/green/card/document/${documentId}`).pipe(map((response) => {
            return response;
        }));
    }
    // Delete UPLOAD Start
    deleteUploadDocument(documentId, companyId, petitionId) {
        return this.httpClient.delete(`/document/${documentId}/company/${companyId}/petition/${petitionId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    // Delete UPLOAD END
    getGeneratedFormDocuments(visatype, caseType, caseId, categoryCode) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/document/category/${categoryCode} `).pipe(map((response) => {
            return response;
        }));
    }
    getDependentFormInfo(visatype, caseType, caseId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/formInfo`).pipe(map((response) => {
            return response;
        }));
    }
    postDependentFormType(visatype, caseType, caseId, taskId, formType, payload) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/form/${formType}/generateGenericForms?taskId=${taskId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getEnotificationAndCCDetails(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/enotificationAndCCDetails`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getTaskDetails(visaType, id) {
        return this.httpClient.get(`/${visaType}/task/${id}`).pipe(map((response) => {
            if (response.data) {
                return response.data;
            }
        }));
    }
}
APIGenerateForms.ɵfac = function APIGenerateForms_Factory(t) { return new (t || APIGenerateForms)(i0.ɵɵinject(i1.HttpClient)); };
APIGenerateForms.ɵprov = i0.ɵɵdefineInjectable({ token: APIGenerateForms, factory: APIGenerateForms.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIGenerateForms, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseGenerateFormsLibraryService {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, referenceLibraryService) {
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.referenceLibraryService = referenceLibraryService;
        this.observableSubscription$ = new Subject();
        this.showDependentVisaPdfGenerateSection = false;
        this.generateFormI130Prep = true;
        this.uploadedFormI130PREP = false;
        this.generateFormI130INTPTR = true;
        this.uploadedFormI130Intptr = false;
        this.dependentFormInfo = {};
        this.formDataArray = {
            common: [],
            primary: [],
            secondary: []
        };
        this.generateFormI129 = true;
        this.generateFormI907 = true;
        this.generateFormG28 = true;
        this.generateFormI130 = true;
        this.generateFormI130A = true;
        this.generateFormI140 = true;
        this.uploadedFormI129 = false;
        this.uploadedFormI907 = false;
        this.uploadedFormG28 = false;
        this.uploadedFormI130 = false;
        this.uploadedFormI130A = false;
        this.uploadedFormI140 = false;
        this.isUploaded = false;
        this.isGeneratedDynimic = true;
        this.isThisGenerateFormForSection = false;
        this.disabledControls = false;
        this.i140Src = '';
        this.g28Src = '';
        this.i907Src = '';
        this.i129Src = '';
        this.gcPDFSrc = '';
        this.i130Src = '';
        this.i130ASrc = '';
        this.gi145Src = '';
        this.gi140Src = '';
        this.i907lastDocDate = "";
        this.g28lastDocDate = "";
        this.i129LastDocDate = "";
        this.i130lastDocDate = "";
        this.i130AlastDocDate = "";
        this.gi145lastDocDate = "";
        this.gi140lastDocDate = "";
        this.g140lastDocDate = "";
        this.docType = 'USCISFORMS';
        this.i130PrepSrc = '';
        this.i130PREPlastDocDate = '';
        this.i130IntptrSrc = '';
        this.i130INTPTRlastDocDate = '';
    }
    onChanges() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                this.stepDetails = data;
                this.getGformInfo();
                this.toggleControlsStatus();
                if (this.stepDetails && this.stepDetails.additionalConfig) {
                    let additionalConfig = JSON.parse(this.stepDetails.additionalConfig);
                    if (additionalConfig.uscisStepConfig) {
                        const showGenerateFormsObj = (additionalConfig.uscisStepConfig.find(x => x.name === 'Show Generate Forms'));
                        this.showDependentVisaPdfGenerateSection = (showGenerateFormsObj && showGenerateFormsObj.value && showGenerateFormsObj.showDependentForm) || ['APPLN400', 'APPLADCARDIMM'].includes(this.inputData.immigrationClassification) ? true : false;
                    }
                }
                else {
                    this.showDependentVisaPdfGenerateSection = DEPENDENT_VISAS.includes(this.inputData.visatype) || ['APPLADCARDNONIM', 'ASYLUM'].includes(this.inputData.visatype) || ['TRVLDOCI131', 'REMVCONDTRES', 'WVRUNLAWPRSNCI601A', 'WVRINADMI601', 'DACAI821D', 'AMERASIANI360', 'WIDOWERUSI360', 'VAWASPOUSEI360', 'VAWACHILDI360', 'VAWAPARENTI360', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR', 'EB4IMMOTH', 'AFFDVTSUPT864', 'AFFDVTSUPTEXMPT864W', 'TEMPPROTSTATI821', 'RELFFORMERSEC191', 'SUSPDPRT881', 'APPLN400', 'APPLTOREPLRESICARD', 'APPLADCARDIMM'].includes(this.inputData.immigrationClassification) || this.inputData.getTaskType === 'I485';
                }
                if (this.showDependentVisaPdfGenerateSection) {
                    this.getDependentFormInfo();
                }
                else {
                    this.getGeneratedForms();
                }
            });
        }
        else {
            this.getGformInfo();
            this.getGeneratedForms();
        }
    }
    getGformInfo() {
        this.apiService.getEnotificationAndCCDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                this.enotificationAndCCDetails = response.data;
                //  console.log("$$$ this.enotificationAndCCDetails", this.enotificationAndCCDetails);
            }
        });
    }
    getGeneratedForms() {
        this.apiService.getGeneratedFormDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'PETFORMDOC')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.status == 200 && response.data) {
                response.data.forEach((element) => {
                    var _a;
                    if (element.fileCategory && element.fileCategory.code === 'G28') {
                        let getFlag = localStorage.getItem("overrideRadioG28");
                        let isGenerated = JSON.parse(getFlag);
                        this.g28Src = element['fileLocation'] || '';
                        this.g28lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_g28 = element.fileCategory.code || ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.attorneyId);
                        this.documentIdG28 = element.id;
                        this.uploadedFormG28 = element.isUploaded;
                        this.uploadedFileNameG28 = element.uploadedFileName;
                        this.generateActiveG28 = element.isActive;
                        if (isGenerated && isGenerated.key == 'G28') {
                            this.generateFormG28 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormG28 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I907') {
                        let getFlag = localStorage.getItem("overrideRadioI907");
                        let isGenerated = JSON.parse(getFlag);
                        this.i907Src = element['fileLocation'] || '';
                        this.i907lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_907 = element.fileCategory.code;
                        this.documentId907 = element.id;
                        this.uploadedFormI907 = element.isUploaded;
                        this.uploadedFileName907 = element.uploadedFileName;
                        this.generateActive907 = element.isActive;
                        if (isGenerated && isGenerated.key == 'I907') {
                            this.generateFormI907 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI907 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I140') {
                        this.i140Src = element['fileLocation'] || '';
                        this.gi140lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_140 = element.fileCategory.code;
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I129') {
                        let getFlag = localStorage.getItem("overrideRadioI129");
                        let isGenerated = JSON.parse(getFlag);
                        this.i129Src = element['fileLocation'] || '';
                        this.i129LastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_129 = element.fileCategory.code;
                        this.documentId129 = element.id;
                        this.uploadedFormI129 = element.isUploaded;
                        this.uploadedFileName129 = element.uploadedFileName;
                        this.generateActive129 = element.isActive;
                        if (isGenerated && isGenerated.key == 'I129') {
                            this.generateFormI129 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI129 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130') {
                        let getFlag = localStorage.getItem("overrideRadioI130");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130Src = element['fileLocation'] || '';
                        this.i130lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_130 = element.fileCategory.code;
                        this.documentId130 = element.id;
                        this.uploadedFormI130 = element.isUploaded;
                        this.uploadedFileName130 = element.uploadedFileName;
                        this.generateActive130 = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130') {
                            this.generateFormI130 = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130 = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130A') {
                        let getFlag = localStorage.getItem("overrideRadioI130A");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130ASrc = element['fileLocation'] || '';
                        this.i130AlastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_130A = element.fileCategory.code;
                        this.documentId130A = element.id;
                        this.uploadedFormI130A = element.isUploaded;
                        this.uploadedFileName130A = element.uploadedFileName;
                        this.generateActive130A = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130A') {
                            this.generateFormI130A = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130A = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'G1145') {
                        this.gi145Src = element['fileLocation'] || '';
                        this.gi145DocDate = element['generatedOn'] ? element['generatedOn'] : '';
                    }
                    if (element.fileCategory && element.fileCategory.code === 'G1450') {
                        this.gi140Src = element['fileLocation'] || '';
                        this.g140lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130PREP') {
                        let getFlag = localStorage.getItem("overrideRadioI130PREP");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130PrepSrc = element['fileLocation'] || '';
                        this.i130PREPlastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_i130Prep = element.fileCategory.code;
                        this.documentId130PREP = element.id;
                        this.uploadedFormI130PREP = element.isUploaded;
                        this.uploadedFileNameI130PREP = element.uploadedFileName;
                        this.generateActiveI130Prep = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130PREP') {
                            this.generateFormI130Prep = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130Prep = element.isGenerated;
                        }
                    }
                    if (element.fileCategory && element.fileCategory.code === 'I130INTPTR') {
                        let getFlag = localStorage.getItem("overrideRadioI130INTPTR");
                        let isGenerated = JSON.parse(getFlag);
                        this.i130IntptrSrc = element['fileLocation'] || '';
                        this.i130INTPTRlastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                        this.fileName_i130Intptr = element.fileCategory.code;
                        this.documentId130INTPTR = element.id;
                        this.uploadedFormI130Intptr = element.isUploaded;
                        this.uploadedFileName130INTPTR = element.uploadedFileName;
                        this.generateActiveI130INTPTR = element.isActive;
                        if (isGenerated && isGenerated.key == 'I130INTPTR') {
                            this.generateFormI130INTPTR = isGenerated.isGenerate;
                        }
                        else {
                            this.generateFormI130INTPTR = element.isGenerated;
                        }
                    }
                });
                if (this.showDependentVisaPdfGenerateSection && this.inputData.getTaskType != 'I485' && !this.isThisGenerateFormForSection) {
                    const dependentResponse = response.data;
                    dependentResponse.forEach((element) => {
                        if (this.formDataArray.primary.length > 0) {
                            this.formDataArray.primary.forEach((ele) => {
                                if (element.fileCategory && element.fileCategory.code === ele.code) {
                                    ele.fileSrc = element['fileLocation'] || '';
                                    ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                    ele.isGenerated = element.isGenerated;
                                    ele.isUploaded = element.isUploaded;
                                    ele.documentId = element.id;
                                    ele.familyId = element.familyId;
                                    ele.uploadedFileName = element.uploadedFileName;
                                    ele.isActive = element.isActive;
                                }
                                /* LJ: Commenting the below as the if and else doing the same thing*/
                                // if (element.fileCategory && element.fileCategory.code === ele.code && element.familyId === ele.applicantId) {
                                //   ele.fileSrc = element['fileLocation'] || '';
                                //   ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                //   ele.isGenerated = element.isGenerated;
                                //   ele.isUploaded = element.isUploaded;
                                //   ele.documentId = element.id;
                                //   ele.familyId = element.familyId;
                                //   ele.uploadedFileName = element.uploadedFileName;
                                //   ele.isActive = element.isActive;
                                // }else if ((this.inputData.visatype === 'ASYLUM' || ['I751', 'I131', 'I601', 'I601A', 'I821D', 'I360', 'I864W', 'I864', 'I191', 'I881', 'I821', 'I765', 'I539','I918','I918A','I918B', 'N400','I90','I129','G325A','I129PREP','I907PREP','I907INTPTR','I129F','I192','I929','I765WS','I485','N400PREP','N400INTPTR','AR11','I131PREP','I90PREP','I90INTPTR','I131INTPTR','I526E','I829','I824', 'I765PREP','I765INTPTR','EOIR33'].includes(ele.code)) && element.fileCategory && element.fileCategory.code === ele.code) {
                                //   ele.fileSrc = element['fileLocation'] || '';
                                //   ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                //   ele.isGenerated = element.isGenerated;
                                //   ele.isUploaded = element.isUploaded;
                                //   ele.documentId = element.id;
                                //   ele.familyId = element.familyId;
                                //   ele.uploadedFileName = element.uploadedFileName;
                                //   ele.isActive = element.isActive;
                                // }
                            });
                        }
                        if (this.formDataArray.secondary.length > 0) {
                            this.formDataArray.secondary[0].secondaryApplicantNameList.forEach((ele) => {
                                if (element.fileCategory && element.fileCategory.code === this.formDataArray.secondary[0].code && element.familyId === ele.applicantId) {
                                    ele.fileSrc = element['fileLocation'] || '';
                                    ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                    ele.isGenerated = element.isGenerated;
                                    ele.isUploaded = element.isUploaded;
                                    ele.documentId = element.id;
                                    ele.familyId = element.familyId;
                                    ele.uploadedFileName = element.uploadedFileName;
                                    ele.isActive = element.isActive;
                                }
                            });
                        }
                        if (this.formDataArray.common.length > 0) {
                            this.formDataArray.common.forEach((ele) => {
                                if (element.fileCategory && element.fileCategory.code === ele.code) {
                                    ele.fileSrc = element['fileLocation'] || '';
                                    ele.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                    ele.isGenerated = element.isGenerated;
                                    ele.isUploaded = element.isUploaded;
                                    ele.documentId = element.id;
                                    ele.familyId = element.familyId;
                                    ele.uploadedFileName = element.uploadedFileName;
                                    ele.isActive = element.isActive;
                                }
                            });
                        }
                    });
                }
                if (this.inputData.getTaskType === 'I485' || this.isThisGenerateFormForSection) {
                    const dependentResponse = response.data;
                    dependentResponse.forEach((element) => {
                        if (this.dependentFormInfo.generateFormFor.length > 0) {
                            this.dependentFormInfo.generateFormFor.forEach((ele) => {
                                if (ele.applicantList && ele.applicantList.length > 0 && element.fileCategory && element.fileCategory.code === ele.formType.code) {
                                    ele.applicantList.forEach((item) => {
                                        if (item.relationshipCode && element.familyId === item.id) {
                                            item.fileSrc = element['fileLocation'] || '';
                                            item.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                            item.isGenerated = element.isGenerated;
                                            item.isUploaded = element.isUploaded;
                                            item.documentId = element.id;
                                            item.familyId = element.familyId;
                                            item.isActive = element.isActive;
                                            item.uploadedFileName = element.uploadedFileName;
                                        }
                                        else if (!item.relationshipCode && !element.familyId && element.fileCategory.code !== 'G28') {
                                            item.fileSrc = element['fileLocation'] || '';
                                            item.lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
                                            item.isGenerated = element.isGenerated;
                                            item.isUploaded = element.isUploaded;
                                            item.documentId = element.id;
                                            item.familyId = element.familyId;
                                            item.isActive = element.isActive;
                                            item.uploadedFileName = element.uploadedFileName;
                                        }
                                    });
                                }
                            });
                        }
                    });
                    // console.log("this.dependentFormInfo",this.dependentFormInfo);
                }
            }
        });
    }
    loadInit() {
        var _a, _b;
        if (this.stepDetails && this.stepDetails.additionalConfig && this.stepDetails.additionalConfig.uscisStepConfig) {
            const showGenerateFormsObj = (this.stepDetails.additionalConfig.uscisStepConfig.find(x => x.name === 'Show Generate Forms'));
            this.showDependentVisaPdfGenerateSection = showGenerateFormsObj && showGenerateFormsObj.value && showGenerateFormsObj.showDependentForm ? true : false;
        }
        else {
            this.showDependentVisaPdfGenerateSection = DEPENDENT_VISAS.includes(this.inputData.visatype) || ['APPLADCARDNONIM', 'ASYLUM'].includes(this.inputData.visatype) || ['TRVLDOCI131', 'REMVCONDTRES', 'WVRUNLAWPRSNCI601A', 'WVRINADMI601', 'DACAI821D', 'AMERASIANI360', 'WIDOWERUSI360', 'VAWASPOUSEI360', 'VAWACHILDI360', 'VAWAPARENTI360', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR', 'EB4IMMOTH', 'AFFDVTSUPT864', 'AFFDVTSUPTEXMPT864W', 'TEMPPROTSTATI821', 'RELFFORMERSEC191', 'SUSPDPRT881', 'APPLN400', 'APPLADCARDIMM'].includes(this.inputData.immigrationClassification) || this.inputData.getTaskType === 'I485';
        }
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.subTaskDetails = data;
            });
        }
        else { // Wizard case
            this.apiService.getTaskDetails(this.inputData.visatype, this.inputData.subTaskId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                this.subTaskDetails = data;
            });
        }
        this.showI130InterperterSection = ((_b = this.subTaskDetails) === null || _b === void 0 ? void 0 : _b.isInterpreterReqd) === 'YES';
        this.onChanges();
    }
    assignFileSrcAndDate(type, date, src, isActive, isGenerated, isUploaded) {
        if (type === 'I140') {
            this.i140Src = src;
            this.gi140lastDocDate = date;
            this.generateFormI140 = isGenerated;
            this.generateActive140 = isActive;
            this.uploadedFormI140 = isUploaded;
        }
        if (type === 'I907') {
            this.i907Src = src;
            this.i907lastDocDate = date;
            this.generateFormI907 = isGenerated;
            this.generateActive907 = isActive;
            this.uploadedFormI907 = isUploaded;
        }
        if (type === 'G28') {
            this.g28Src = src;
            this.g28lastDocDate = date;
            this.generateFormG28 = isGenerated;
            this.generateActiveG28 = isActive;
            this.uploadedFormG28 = isUploaded;
        }
        if (type === 'I129') {
            this.i129Src = src;
            this.i129LastDocDate = date;
            this.generateFormI129 = isGenerated;
            this.generateActive129 = isActive;
            this.uploadedFormI129 = isUploaded;
        }
        if (type === 'I130') {
            this.i130Src = src;
            this.i130lastDocDate = date;
            this.generateFormI130 = isGenerated;
            this.generateActive130 = isActive;
            this.uploadedFormI130 = isUploaded;
        }
        if (type === 'I130A') {
            this.i130ASrc = src;
            this.i130AlastDocDate = date;
            this.generateFormI130A = isGenerated;
            this.generateActive130A = isActive;
            this.uploadedFormI130A = isUploaded;
        }
        if (type === 'G1450') {
            this.gi140Src = src;
            this.g140lastDocDate = date;
        }
        if (type === 'G1145') {
            this.gi145Src = src;
            this.gi145DocDate = date;
        }
    }
    postGenerateDoc(gcFormtype) {
        if (gcFormtype === 'I129' && this.inputData.taskTypeSaveJsonId && !['H3B', 'H3A', 'E3'].includes(this.inputData.getTaskType)) {
            this.postDependentGenerateDoc(gcFormtype, 0, 'false', null);
        }
        else {
            const payload = {
                formType: gcFormtype,
            };
            this.apiService.postFormType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, gcFormtype, payload)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.data) {
                    this.gcPDFSrc = response.data['fileLocation'] || '';
                    if (this.gcPDFSrc != '') {
                        const date = response.data['generatedOn'] ? response.data['generatedOn'] : '';
                        const src = this.gcPDFSrc;
                        const isActive = response.data.isActive;
                        const isGenerated = response.data.isGenerated;
                        const isUploaded = response.data.isUploaded;
                        this.assignFileSrcAndDate(gcFormtype, date, src, isActive, isGenerated, isUploaded);
                        this.toastr.success(response.message, "Success"); // all done
                        this.getGeneratedForms();
                    }
                }
            });
        }
    }
    // This function generates a form for a dependent applicant(s) either for all of them or only for selected one(s).
    // Arguments:
    // formType: Type of the form to be generated. (string)
    // id: ID of the selected dependent applicant(s). (string)
    // generateAll: Flag indicating if forms need to be generated for all dependents. (string)
    // relationshipCode: Code representing the dependent's relationship with the main applicant. (string)
    postDependentGenerateDoc(formType, id, generateAll, relationshipCode) {
        var _a;
        // Initialize an empty array for storing the dependent applicant IDs.
        const applicantList = [];
        // If generating forms for all dependents is required or if the dependent has ASYLUM visa type and not ASYLRELATIVE classification,
        // add the IDs of all non-primary applicants to the applicantList array.
        if (generateAll === 'true' || (this.inputData.visatype === 'ASYLUM' && this.inputData.immigrationClassification !== 'ASYLRELATIVE' && ((_a = this.dependentFormInfo.applicantList) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
            const secondaryApplicants = this.dependentFormInfo.applicantList.filter(item => !item.primaryApplicant);
            applicantList.push(...secondaryApplicants.map(({ id }) => id));
        }
        // If generating form for a specific dependent, add the given ID to the applicantList array.
        else if (id && relationshipCode) {
            applicantList.push(id);
        }
        // Generate the form with the given attributes (formType, generateAll, relationshipCode, applicantList).
        this.generateForm(formType, generateAll, relationshipCode, applicantList);
    }
    generateForm(formType, generateAll, relationshipCode, applicantList) {
        let applicatListVal;
        // const formTypeVal = this.inputData.caseType === "I129EFILING" ? 'I129preparer' : formType;
        if ((this.inputData.visatype === 'ASYLUM') || relationshipCode === null) {
            if ((this.inputData.immigrationClassification != "ASYLRELATIVE" && (applicantList === null || applicantList === void 0 ? void 0 : applicantList.length) === 0) || (formType === 'I589' && this.inputData.immigrationClassification === "ASYLAFFIRM")) {
                applicatListVal = [];
            }
            else {
                applicatListVal = applicantList;
            }
        }
        else {
            applicatListVal = applicantList;
        }
        const payload = {
            "applicantList": applicatListVal,
            "generateAll": generateAll === 'true' ? true : false
        };
        this.apiService.postDependentFormType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.subTaskId, formType, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                this.toastr.success(response.message, "Success");
                this.getGeneratedForms();
            }
        });
    }
    getDependentFormInfo() {
        this.apiService.getDependentFormInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b, _c, _d, _e;
            try {
                if (this.inputData.getTaskType === 'I485' || response.data.generateFormFor) {
                    this.isThisGenerateFormForSection = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.generateFormFor) ? true : false;
                    this.dependentFormInfo = response.data;
                    if (this.dependentFormInfo.generateFormFor.length > 0) {
                        this.dependentFormInfo.generateFormFor.forEach((element) => {
                            if (element.applicantList && element.applicantList.length > 0) {
                                element.applicantList.forEach((ele) => {
                                    ele.isGenerated = true;
                                    ele.isUploaded = false;
                                });
                                this.getGeneratedForms();
                            }
                        });
                    }
                }
                else {
                    this.dependentFormInfo = response.data;
                    const primaryApplicant = this.inputData.immigrationClassification && this.inputData.immigrationClassification === "AFFDVTSUPT864" ? (this.dependentFormInfo.primaryApplicantList).find(item => item.primaryApplicant) : this.dependentFormInfo.primaryApplicantList ? (this.dependentFormInfo.primaryApplicantList).find(item => item.primaryApplicant) : (this.dependentFormInfo.applicantList).find(item => item.primaryApplicant);
                    const secondaryApplicant = (this.dependentFormInfo.applicantList).filter(item => !item.primaryApplicant);
                    const secondaryApplicantNameList = secondaryApplicant.map(function (ele) {
                        return {
                            applicantName: ele.firstName ? `${ele.firstName} ${ele.lastName}` : null, applicantId: ele.id, isGenerated: true, isUploaded: false, relationshipCode: ele.relationshipCode, relationshipName: ele.relationshipName
                        };
                    });
                    this.formDataArray.common = this.dependentFormInfo.formTypes.common;
                    if (this.dependentFormInfo.formTypes && ((_c = (_b = this.dependentFormInfo.formTypes) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                        this.formDataArray.primary = this.dependentFormInfo.formTypes.primary.map(function (ele) {
                            return Object.assign(Object.assign({}, ele), { applicantName: (primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.firstName) ? `${primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.firstName} ${primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.lastName}` : null, applicantId: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.id, isGenerated: true, isUploaded: false, relationshipCode: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.relationshipCode, relationshipName: primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.relationshipName });
                        });
                    }
                    if (this.dependentFormInfo.formTypes && ((_e = (_d = this.dependentFormInfo.formTypes) === null || _d === void 0 ? void 0 : _d.secondary) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                        this.formDataArray.secondary = this.dependentFormInfo.formTypes.secondary.map(function (ele) {
                            return Object.assign(Object.assign({}, ele), { secondaryApplicantNameList: secondaryApplicantNameList });
                        });
                    }
                }
                this.getGeneratedForms();
            }
            catch (error) {
                console.log("error outside", error);
            }
        });
    }
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
    }
    viewGenerateDoc(src) {
        const docPath = src.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    onDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseGenerateFormsLibraryService.ɵfac = function BaseGenerateFormsLibraryService_Factory(t) { return new (t || BaseGenerateFormsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(APIGenerateForms), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.ReferenceLibraryService)); };
BaseGenerateFormsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseGenerateFormsLibraryService, factory: BaseGenerateFormsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseGenerateFormsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.ToastrService }, { type: APIGenerateForms }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.ReferenceLibraryService }]; }, null); })();

/*
 * Public API Surface of base-generate-forms-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIGenerateForms, BaseGenerateFormsLibraryService };
//# sourceMappingURL=base-generate-forms-library.js.map
